(function () {
  if (window.__hpv2MobileSliderLoaded) return;
  window.__hpv2MobileSliderLoaded = true;
  function initSlider(slider) {
    if (slider.dataset.hpv2SliderBound === 'true') return;
    slider.dataset.hpv2SliderBound = 'true';

    var autoplay = slider.dataset.autoplay === 'true';
    var delay = Math.max(3000, Number(slider.dataset.autoplayDelay) || 5000);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer;
    var resumeTimer;

    function isMobile() {
      return window.matchMedia('(max-width: 719px)').matches;
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      if (resumeTimer) window.clearTimeout(resumeTimer);
      timer = null;
      resumeTimer = null;
    }

    function start() {
      stop();
      if (!autoplay || reduceMotion || !isMobile() || document.hidden) return;
      timer = window.setInterval(function () {
        var slides = slider.children;
        if (slides.length < 2) return;
        var gap = parseFloat(window.getComputedStyle(slider).columnGap) || 16;
        var step = slides[0].getBoundingClientRect().width + gap;
        var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 8;
        slider.scrollTo({ left: atEnd ? 0 : slider.scrollLeft + step, behavior: 'smooth' });
      }, delay);
    }

    // No pause button: the rail is a native scroller, so a swipe moves it and
    // any touch, hover or focus holds autoplay. It picks up again a moment
    // after the visitor lets go, so a swipe never fights the timer.
    function resumeSoon() {
      stop();
      resumeTimer = window.setTimeout(start, delay);
    }

    slider.addEventListener('pointerdown', stop, { passive: true });
    slider.addEventListener('touchstart', stop, { passive: true });
    slider.addEventListener('focusin', stop);
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('pointerup', resumeSoon, { passive: true });
    slider.addEventListener('touchend', resumeSoon, { passive: true });
    slider.addEventListener('focusout', resumeSoon);
    slider.addEventListener('mouseleave', resumeSoon);
    document.addEventListener('visibilitychange', start);
    window.addEventListener('resize', start);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-hpv2-mobile-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
